import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../../../components/Loader/Loader'

import WhyHostFormBlock7 from '../../../../components/siteadmin//WhyHostPageSettings/WhyHostFormBlock7/WhyHostFormBlock7';
import getWhyHostPageSettings from './getWhyHostPageSettings.graphql';
import { withQuery } from '../../../../hoc/withGraphql';

import s from './EditReviewsWhyHost.css';

const EditReviewsWhyHost = (props) => {

    const { data: { loading, getWhyHostReview }, reviewId } = props;
    if (loading) {
        return <Loader type={"text"} />;
    } else {
        let initialValues = getWhyHostReview && getWhyHostReview.result;
        if (initialValues) {
            initialValues = {
                ...initialValues,
                dynamicAdminReviews: initialValues.dynamicAdminReviews && initialValues.dynamicAdminReviews.length > 0 ? initialValues.dynamicAdminReviews : [{
                    userName: initialValues.userName,
                    reviewContent: initialValues.reviewContent,
                    language: 'en'
                }]
            };
        }
        return <WhyHostFormBlock7 initialValues={initialValues} reviewId={reviewId} />
    }
}

EditReviewsWhyHost.defaultProps = {
    data: {
        loading: false
    }
};

export default compose(
    withStyles(s),
    withQuery(getWhyHostPageSettings, {
        options: (props) => ({
            variables: {
                reviewId: props.reviewId,
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
)(EditReviewsWhyHost);